$(document).ready(function () {
  function checkScroll(scrollOffset, block, blockH, customClass) {
    if (scrollOffset >= blockH) {
      block.addClass(customClass);
      block.css("top", headerH);
    } else {
      block.removeClass(customClass);
      block.css("top", 0);
    }
  }

  function checkScroll2(scrollOffset, block, blockH, blockOffset, customClass) {
    if (scrollOffset >= blockOffset + blockH) {
      block.addClass(customClass);
      block.css("top", headerH);
    } else {
      block.removeClass(customClass);
      block.css("top", 0);
    }
  }

  let headerH = $("#header").innerHeight();
  let scrollOffset = $(window).scrollTop();

  const matchesInnerNav = $("#matchesInnerNav");
  let matchesInnerNavSumm = "";

  if (matchesInnerNav.length) {
    const matchesInnerNavH = matchesInnerNav.innerHeight();
    const matchesInnerNavOffset = matchesInnerNav.offset().top;
    matchesInnerNavSumm = matchesInnerNavOffset + matchesInnerNavH;

    checkScroll(
      scrollOffset,
      matchesInnerNav,
      matchesInnerNavSumm,
      "matches__inner__nav--fixed"
    );
  }

  const matchesInnerNavH = matchesInnerNav.innerHeight();

  const sectionNavSort = $("#sectionNavSort");
  let sectionNavSumm = "";
  if (sectionNavSort.length) {
    const sectionNavSortH = sectionNavSort.innerHeight();
    const sectionNavSortOffset = sectionNavSort.offset().top;
    sectionNavSumm = sectionNavSortOffset + sectionNavSortH;

    checkScroll(
      scrollOffset,
      sectionNavSort,
      sectionNavSumm,
      "custom__section__nav__sort--fixed"
    );
  }

  const filterPannel = $("#filterPannel");
  let filterPannelSumm = "";

  if (filterPannel.length) {
    const filterPannelH = filterPannel.innerHeight();
    const filterPannelOffset = filterPannel.offset().top;
    filterPannelSumm = filterPannelOffset + filterPannelH;

    checkScroll(
      scrollOffset,
      filterPannel,
      filterPannelSumm,
      "filter__pannel--fixed"
    );
  }

  const headerBk = $("#headerBk");

  let roboStats = $("#robo_stats");
  let roboStatsH;
  let roboStatsOffstet;

  if (roboStats.length) {
    roboStatsH = roboStats.innerHeight();
    roboStatsOffstet = roboStats.offset().top;

    checkScroll2(
      scrollOffset,
      roboStats,
      roboStatsH,
      roboStatsOffstet,
      "robo-stats--fixed"
    );
  }

  checkScroll(
    scrollOffset,
    matchesInnerNav,
    matchesInnerNavH,
    "matches__inner__nav--fixed"
  );

  checkScroll(scrollOffset, headerBk, headerH, "header__bk--fixed");

  $(window).on("scroll", function () {
    headerH = $("#header").innerHeight();
    scrollOffset = $(this).scrollTop();

    if (matchesInnerNav.length) {
      checkScroll(
        scrollOffset,
        matchesInnerNav,
        matchesInnerNavSumm,
        "matches__inner__nav--fixed"
      );
    }

    if (sectionNavSort.length) {
      checkScroll(
        scrollOffset,
        sectionNavSort,
        sectionNavSumm,
        "custom__section__nav__sort--fixed"
      );
    }

    if (filterPannel.length) {
      checkScroll(
        scrollOffset,
        filterPannel,
        filterPannelSumm,
        "filter__pannel--fixed"
      );
    }

    checkScroll(scrollOffset, headerBk, headerH, "header__bk--fixed");

    if (roboStats.length) {
      checkScroll2(
        scrollOffset,
        roboStats,
        roboStatsH,
        roboStatsOffstet,
        "robo-stats--fixed"
      );
    }
  });

  if ($(".main--sidebar__mob .sidebar--bk").length) {
    let topPos = $(".main--sidebar__mob .sidebar--bk").offset().top;

    $(window).scroll(function () {
      let top = $(window).scrollTop() + 98;
      let height = $(".sidebar--bk").outerHeight();

      let pip = $(".footer").offset().top - 56;

      if (top > topPos && top < pip - height) {
        $(".sidebar--bk").addClass("fixed-official").removeAttr("style");
      } else if (top > pip - height) {
        $(".sidebar--bk").removeClass("fixed-official").css({
          position: "absolute",
          width: "277px",
          bottom: "0",
          top: "auto",
        });
      } else {
        $(".sidebar--bk").removeClass("fixed-official");
      }
    });
  }
});
